import React from 'react';
import './VideoSection.scss';
import ReactPlayer from 'react-player';

const VideoSection = ({strapiData}) => {
    return (
        <section className="video-section">
            <h2 className="video-section__title">{strapiData.Texte}</h2>
            <div className="video-section__container">
            <div className="video-section__wrapper">
                <ReactPlayer
                    className="video-section__player"
                    url={strapiData.LienVideo}
                    width="100%"
                    height="100%"
                    controls={true}
                    playing={false}
                    light={false}
                    pip={true}
                    config={{
                        youtube: {
                            playerVars: {
                                modestbranding: 1,
                                rel: 0
                            }
                        }
                    }}
                />
            </div>
            </div>
        </section>
    );
};

export default VideoSection;